<template>
  <b-container >
       <b-col class="mt-2" cols="6">
                        <h6>Attachments:</h6>
                          <b-form-file v-for="(val,index) in file" :key="index"
                          v-model="val.fileName"
                          :state="Boolean(val.fileName)"
                          placeholder="Choose a file..."
                          drop-placeholder="Drop file here..."
                          ></b-form-file>
                        <!-- <b-form-file  :file-name-formatter="formatNames"> -->
                          <label @click="addmorefile">
                        <font-awesome-icon icon="plus-circle"  /> Add More </label>
                        <h6 class="info"> Allowed File Extensions: .jpg, .gif, .jpeg, .png </h6>
                        <b-button @click="submit" variant="primary">Reply</b-button>
                    </b-col>
   </b-container >
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import {HTTPTICKET,HTTPMentor,HTTPDynamic} from "@/axios";
import Swal from 'sweetalert2'

export default {
  name: 'HelloWorld',
  data () {
    return {
      loading:false,
      comment:``,
      file:[{
        fileName : null,
      }],
      filemultisuccess:[],
      filecomment:null,
      filesuccess:'',
      detailall:[],
      }
  },
  components:{
  },
  created(){
    // this.loading = true
   
  },
  mounted(){
    console.log(this.$route.params.id)
      //  this.errorcatch()
  },
    computed: {
       ...mapState(["isloginuser"]),
    },
    methods:{
            addmorefile(){
      this.file.push({fileName : null})
      },
      errorcatch(){
          return
      Swal.fire(
                        'Error',
                        'Please check your network connection',
                        'error'
                        )
      },
      async submit(){
        // this.uploadfile_multi().then(console.log(this.filemultisuccess))
       await this.uploadfile_multi2()
       console.log('dsadsaldmksdandskank',this.filemultisuccess)
      },
     uploadfile_multi(){
       return new Promise((resolve,reject) => {
       for (let d = 0; d < this.file.length; d++) {
                // const element = array[d];
                 let formData = new FormData();
                formData.append('file', this.file[d].fileName);
                console.log(formData)
                HTTPTICKET.defaults.headers.common.Authorization = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI1Y2Y4ODljOWIyYTJmMTNiOTMyMGUyZDMiLCJ1c2VyTGV2ZWwiOjUwLCJpYXQiOjE1NTk5ODMxNjUsImV4cCI6MTU1OTk5Mzk2NX0.9nMeRi03StChnMqo-kn64nOcu9PJ9JRTV6TDs37lqmo`;
                HTTPTICKET.post(`upload/commentFile`,formData)
                .then(res => {
                  console.log(res.data)
                    if (res.data.success) {
                      this.filemultisuccess.push({fileName:res.data.obj})
                    }
                })
                .catch(e => {  
                   this.errorcatch()
                  this.loading = false
                    console.log("upload/commentFile",e);
             });
             console.log(this.file.length+':'+d)
             console.log(this.file)
           }
           resolve()
        })          
      },
       uploadfile_multi2(){
        for (let d = 0; d < this.file.length; d++) {
                 let formData = new FormData();
                formData.append('file', this.file[d].fileName);
                console.log(formData)
                HTTPTICKET.defaults.headers.common.Authorization = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI1Y2Y4ODljOWIyYTJmMTNiOTMyMGUyZDMiLCJ1c2VyTGV2ZWwiOjUwLCJpYXQiOjE1NTk5ODMxNjUsImV4cCI6MTU1OTk5Mzk2NX0.9nMeRi03StChnMqo-kn64nOcu9PJ9JRTV6TDs37lqmo`;
                HTTPTICKET.post(`upload/commentFile`,formData)
                .then(res => {
                  console.log(res.data)
                    if (res.data.success) {
                      this.filemultisuccess.push({fileName:res.data.obj})
                    }
                })
                .catch(e => {  
                   this.errorcatch()
                  this.loading = false
                    console.log("upload/commentFile",e);
             });
             console.log(this.file.length+':'+d)
             console.log(this.file)
           }

      },
  },
  components:{
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/testpromise.vue